import { render, staticRenderFns } from "./AdminCreditLimitOverview.vue?vue&type=template&id=18901c2b&scoped=true&"
import script from "./AdminCreditLimitOverview.vue?vue&type=script&lang=js&"
export * from "./AdminCreditLimitOverview.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreditLimitOverview.vue?vue&type=style&index=0&id=18901c2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18901c2b",
  null
  
)

export default component.exports